import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityProtectedBase } from '@app/shared/components/security-protected/security-protected';
import { QuickLinksService } from '../../services/quick-links.service';
import { FeatureService } from '@app/core/services/feature.service';
import { features } from '@app/consts';
import { finalize, from, Observable } from 'rxjs';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { QuickLink } from '../../models/quick-links.model';
import { OidcAuthService } from '@app/core/services/oidc-auth.service';
import { modules } from '@app/consts/modules';
import { ModuleConfigurationService } from '@app/core/services/module-configuration/module-configuration.service';

@Component({
  selector: 'app-quick-links-display',
  templateUrl: './quick-links-display.component.html',
  styleUrls: ['./quick-links-display.component.scss']
})
export class QuickLinksDisplayComponent extends SecurityProtectedBase implements OnInit {
  public modules: typeof modules = modules;
  quickLinks: QuickLink[] = [];
  loading: boolean;
  systemLinks = {
    TOIL: '',
    TIMEOFF: '',
    DIRECTORY: '/TalentTrack'
  }
  user$: any;

  constructor(
    private router: Router,
    private oidcAuthService: OidcAuthService,
    private quickLinksService: QuickLinksService,
    featureService: FeatureService,
    private moduleConfigurationService: ModuleConfigurationService,
  ) {
    super(featureService, features.QUICK_LINKS);
    this.user$ = this.oidcAuthService.userProfile;
    this.systemLinks.TOIL = `TalentTrack/Edit/${this.user$.userId}/TimeOff/TOIL`;
    this.systemLinks.TIMEOFF = `TalentTrack/Edit/${this.user$.userId}/TimeOff/TimeOffHistory`;
  }

  ngOnInit(): void {
    this.getQuickLinks();
  }

  getQuickLinks() {
    this.loading = true;

    from(this.quickLinksService.getAllQuickLinks(null, 'orderNumber-asc')).subscribe(
      {
        next: (v) => {
          this.quickLinks = v.data;
          if(this.moduleConfigurationService.hasModuleAccess(modules.TOIL) === false) {
            this.quickLinks = this.quickLinks.filter(link => link.systemLink?.id !== 'TOIL');
          }
          if(this.moduleConfigurationService.hasModuleAccess(modules.TIME_OFF) === false) {
            this.quickLinks = this.quickLinks.filter(link => link.systemLink?.id !== 'TIMEOFF');
          }
        },
        error: (e) => this.loading = false,
        complete: () => this.loading = false
      }
    );

  }

  openQuickLink(quickLink: QuickLink) {
    if (quickLink.externalUrl) {
      window.open(quickLink.externalUrl, '_blank');
    } else if (quickLink.systemLink && quickLink.systemLink.id) {
      this.router.navigate([this.systemLinks[quickLink.systemLink.id]]);
    }
  }
}
